import { Button, List, ListItem, ListItemText, Paper } from "@mui/material";
import React from "react";
import { SystemValueInterface } from "../../Api/System";
import CategoryTitle from "../atoms/CategoryTitle";
import CancelPolicyDialog from "./CancelPolicyDialog";

interface CancelSystemSettingsProps {
    systemValue?: SystemValueInterface
    onSave?: (key: string, value: string) => void
}

const CancelSystemSettings: React.FC<CancelSystemSettingsProps> = ({
    systemValue,
    onSave
}) => {
    const [dialog, setDialog] = React.useState<boolean>(false)

    return (
        <Paper sx={{ margin: "10px" }}>
            <CategoryTitle
                text="キャンセル関連設定"
            />
            <List>
                <ListItem>
                    <ListItemText primary={"キャンセルポリシー設定"} />
                    <Button
                        variant="outlined"
                        sx={{
                            maxWidth: 300
                        }}
                        fullWidth
                        onClick={() => {
                            setDialog(true)
                        }}
                    >
                        設定
                    </Button>
                </ListItem>
            </List>
            <CancelPolicyDialog
                open={dialog}
                onClose={() => {
                    setDialog(false)
                }}
            />
        </Paper>
    );
}

export default CancelSystemSettings